import { render, staticRenderFns } from "./Staff Head.vue?vue&type=template&id=23f560a7&scoped=true&"
import script from "./Staff Head.vue?vue&type=script&lang=js&"
export * from "./Staff Head.vue?vue&type=script&lang=js&"
import style0 from "./Staff Head.vue?vue&type=style&index=0&id=23f560a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f560a7",
  null
  
)

export default component.exports